import React, { useState, useEffect, useContext } from 'react';
import {
  makeStyles,
  Grid,
  Typography,
  Divider,
  Button,
  Container,
  TextField,
  Fade,
  Select,
  MenuItem,
  CircularProgress
} from '@material-ui/core';
import { isMobileOnly } from 'react-device-detect';
import CustomModal from '../../components/CustomModal';
import { Context as AuthContext } from '../../context/AuthContext';
import { Context as CategoryContext } from '../../context/CategoryContext';

const AddSubCategory = ({ history }) => {
  const [englishSubcategoryName, setEnglishSubcategoryName] = useState('');
  const [arabicSubcategoryName, setArabicSubcategoryName] = useState('');
  const [subCategoryImage, setSubCategoryImage] = useState(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  const [modalText, setModalText] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const [showConfirmButton, setShowConfirmButton] = useState(false);
  const [resetPhoto, setResetPhoto] = useState(false);
  const [loading, setLoading] = useState(false);

  const {
    state: { token },
    tryLocalSignin
  } = useContext(AuthContext);
  const {
    fetchCategories,
    uploadSubCategory,
    state: { categories }
  } = useContext(CategoryContext);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      await fetchCategories();
      setLoading(false);
    }

    tryLocalSignin(history, '/add_subcategory');
    fetchData();
  }, []);

  const classes = useStyles();

  const handleSubmit = async () => {
    setLoading(true);

    const res = await uploadSubCategory(
      selectedCategoryId,
      arabicSubcategoryName,
      englishSubcategoryName,
      subCategoryImage
    );

    if (res.error) {
      setModalText('There is a problem in uploading the subcategory!');
    } else {
      setModalText('Subcategory uploaded successfully');
      setArabicSubcategoryName('');
      setEnglishSubcategoryName('');
      setSubCategoryImage(null);
      setSelectedCategoryId(null);
    }

    setShowConfirmButton(false);
    setModalVisible(true);
    setLoading(false);
  };

  const validateImagesSizes = async event => {
    event.preventDefault();

    Object.values(event.target.files).forEach(imgFile => {
      if (imgFile.size > 1048576) {
        setModalText('There are images that exceed 1MB limit size');
        setModalVisible(true);
        setShowConfirmButton(false);
        setResetPhoto(true);
        return;
      }
    });

    setSubCategoryImage(event.target.files[0]);
  };

  if (!token) {
    return null;
  }

  return (
    <div>
      <Container style={{ marginTop: '1%' }}>
        {loading && (
          <CircularProgress
            style={{
              display: 'flex',
              position: 'absolute',
              alignSelf: 'center',
              top: '50%',
              left: '50%'
            }}
          />
        )}
        <Fade timeout={1000} in={true}>
          <div>
            <Typography className={classes.title}>Add Subcategory</Typography>
            <Divider />
            <Grid
              className={
                isMobileOnly ? classes.mobileContainer : classes.container
              }
              container
            >
              <Grid md={4} xs={12}>
                <Select
                  placeholder="Choose category"
                  variant="outlined"
                  className={classes.selectCategory}
                  onChange={event =>
                    setSelectedCategoryId(event.target.value._id)
                  }
                >
                  {categories.map(category => {
                    return (
                      <MenuItem value={category}>
                        {category.englishName}
                      </MenuItem>
                    );
                  })}
                </Select>
              </Grid>
              <Grid md={4} xs={12}>
                <TextField
                  value={englishSubcategoryName}
                  onChange={e => setEnglishSubcategoryName(e.target.value)}
                  placeholder="English Subcategory Name"
                  variant="outlined"
                  className={classes.textField}
                />
              </Grid>
              <Grid md={4} xs={12}>
                <TextField
                  value={arabicSubcategoryName}
                  onChange={e => setArabicSubcategoryName(e.target.value)}
                  placeholder="Arabic Subcategory Name"
                  variant="outlined"
                  className={classes.textField}
                />
              </Grid>
              <Grid direction="row" md={4} xs={12}>
                <Button
                  className={classes.uploadButton}
                  variant="contained"
                  component="label"
                  color="primary"
                >
                  Upload Photo
                  <input
                    name="photos"
                    type="file"
                    id="files"
                    onChange={event => validateImagesSizes(event)}
                    hidden
                  />
                </Button>
                <Typography variant="h6">
                  {subCategoryImage ? 'Photo Selected' : 'Please Select Photo'}
                </Typography>
              </Grid>
            </Grid>
            <Button
              variant="contained"
              color="secondary"
              className={classes.submitButton}
              onClick={() => {
                if (
                  !englishSubcategoryName ||
                  !arabicSubcategoryName ||
                  !subCategoryImage
                ) {
                  return;
                }

                setModalText('Do you want to submit this?');
                setShowConfirmButton(true);
                setModalVisible(true);
                setResetPhoto(false);
              }}
            >
              Submit
            </Button>
            <CustomModal
              title="Warning!"
              content={modalText}
              visible={modalVisible}
              onCancel={() => {
                setModalVisible(false);
                if (resetPhoto) setSubCategoryImage(null);
              }}
              onConfirm={handleSubmit}
              showConfirmButton={showConfirmButton}
              loading={loading}
            />
          </div>
        </Fade>
      </Container>
    </div>
  );
};

const useStyles = makeStyles({
  title: {
    fontSize: '1.6em'
  },
  container: {
    marginTop: '2%'
  },
  mobileContainer: {
    marginTop: '5%'
  },
  selectCategory: {
    width: isMobileOnly ? '85%' : '50%',
    marginBottom: isMobileOnly ? '5%' : 0
  },
  textField: {
    width: isMobileOnly ? '85%' : '70%',
    marginBottom: isMobileOnly ? '5%' : 0
  },
  uploadButton: {
    marginTop: '5%'
  },
  submitButton: {
    float: 'right',
    width: isMobileOnly ? '35%' : '10%',
    marginTop: isMobileOnly ? '5%' : 0,
    marginBottom: '2%'
  }
});

export default AddSubCategory;
